import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  orderNrColumnForAdmin,
  statusColumn,
  teamColumn,
  orderDateColumn,
  customerColumn,
  licensePlateColumn,
  partnerColumn,
  insuranceColumn,
  kindColumn,
  infoColumn,
} from '../../montage-orders/order-columns';
import { setObjectValue } from '@util/utils';

import { EditCellRendererComponent } from '@grid-cell/edit-cell-renderer.component';
import { ColDef } from '../grid-types';
import { GridColumnStyles, MyLog } from '@common/common';
import { debounceTime } from 'rxjs/operators';
import { addMonths, isValidDate } from '@util/date-utils';
import { getClientRect } from '@util/web-utils';

export const editColumn: ColDef = {
  headerName: '',
  width: 80,
  minWidth: 70,
  editable: false,
  cellClass: 'tablan-edit-cell',
  cellRenderer: EditCellRendererComponent,
  cellRendererParams: {
    canDelete: true,
    canEdit: true,
    url: '/orders/'
  },
  pinned: 'right',
};

export function getRowStyle(params: any) {
  var c = (params.node.rowIndex % 2 === 0) ? '#F0F0F0' : 'white';
  return { background: c };
}

@Component({
  selector: 'app-orders-grid',
  templateUrl: './orders-grid.component.html',
})
export class OrdersGridComponent implements OnInit {

  _suppressRowTransform = false;
  @Input() suppressRowTransform = false;

  noRowsTemplate = 'Keine Daten vorhanden';

  h: any;

  w = 600;

  lastWidth: any;

  showGrid = false;

  dateChanged = false;

  startDate = new Date();

  endDate = addMonths(new Date(), 1);

  wId: any;

  lastHeight: any;

  customStyle: any = {};

  intId: any;

  gridOptions: any;

  inputFC = new UntypedFormControl();

  rowData: any[] = [];

  public _filter = true;
  @Input() set filter(filter: boolean) {
    this._filter = filter;
  }

  @Input() set options(options: any) {
    this.setGridOptions(options);
  }

  _ds = false;
  @Input() set datesearch(ds: boolean) {
    this._ds = ds;
  }

  _ts = true;
  @Input() set textsearch(ts: boolean) {
    this._ts = ts;
  }

  //_startDate: any;
  @Input() set startdate(d: any) {
    //this._startDate = d;
    if (!this.dateChanged) {
      this.startDate = d;
    }
  }

  //_endDate: any;
  @Input() set enddate(d: any) {
    //this._endDate = d;
    if (!this.dateChanged) {
      this.endDate = d;
    }
  }

  getStartDate(): any {
    return this.startDate;
  }

  getEndDate(): any {
    return this.endDate;
  }

  onStartDateChange($event: any) {
    this.startDate = this.onDateChange($event);
  }

  onEndDateChange($event: any) {
    this.endDate = this.onDateChange($event);
  }

  onDateChange($event: any) {
    this.dateChanged = true;
    return $event && isValidDate($event) ? $event : null;
  }

  search() {
    this.filterClickChange.emit({
      text: this.inputFC.value,
      from: this.startDate,
      to: this.endDate
    });
  }

  setGridOptions(gridOptions: any) {
    if (gridOptions) {
      this.gridOptions = gridOptions;
      this.updateGridWidth();
    }
  }

  @Input('filter-func') filterFunc: any;

  @Input() autofit = false;

  _gridWrapper?: ElementRef;
  @ViewChild('gridWrapper', {
    read: ElementRef
  }) set gridWrappper(wrap: ElementRef) {
    this._gridWrapper = wrap;
    this.wId && clearInterval(this.wId);
    this.wId = null;

    if (!wrap) {
      return;
    }

    this.wId = setInterval(() => {
      const r = getClientRect(this._gridWrapper?.nativeElement);

      if (r && r.height) {
        const newHeight = r.height - 16;
        if (newHeight && newHeight !== this.lastHeight) {
          this.lastHeight = newHeight;
          this.h = newHeight;
          MyLog.log('Update height', newHeight);
          this.updateStyle();
        }
      }
    }, 50);
  }

  updateStyle(): void {
    const customStyle: any = {
      width: this.w + 'px'
    };
    this.h && setObjectValue(customStyle, 'height', (this.h) + 'px');

    this.customStyle = customStyle;
  }



  private _grid: any;

  @ViewChild('grid') set grid(grid: ElementRef) {
    this._grid = grid;
    /*
    if (grid) {
      //MyLog.log('GRID:', (grid as any).api);
      const api = (grid as any).api;

      if (isFunction(api?.addEventListener)) {
        api?.addEventListener('destroy', () => {
          MyLog.log('Destroyed');
        });
      }
    }
    */
    this.updateColumnSizes();
  }

  private _wrapper!: ElementRef;
  @ViewChild('wrapper') set wrapper(wrap: ElementRef) {
    if (this._wrapper !== wrap) {
      this._wrapper = wrap;
      this.updateGridWidth();
    }
  }

  updateGridWidth() {
    const wrap = this._wrapper;
    if (wrap) {
      try {
        setTimeout(() => {
          const elem = wrap?.nativeElement as HTMLElement;
          if (elem) {
            //const w = elem.clientWidth;
            const newWidth = elem.clientWidth - 20;
            if (newWidth && newWidth !== this.lastWidth) {
              this.lastWidth = newWidth;
              this.w = newWidth;
              this.updateStyle();
              this.updateColumnSizes();
              this.showGrid = true;
            }
          }
        }, 100);
      } catch (e) { }
    }
  }

  @Input() visible = false;

  @Output() filterChange = new EventEmitter();
  @Output() filterClickChange = new EventEmitter();

  static defaultOptions() {
    return {
      headerHeight: 40,
      defaultColDef: {
        headerClass: 'def-col',
        autoHeight: true,
        cellClass: GridColumnStyles.CELL_CLASS_STRING
      },
      columnDefs: [
        orderNrColumnForAdmin,
        statusColumn,
        infoColumn,
        teamColumn,
        orderDateColumn,
        customerColumn,
        licensePlateColumn,
        partnerColumn,
        insuranceColumn,
        kindColumn,
        editColumn,
      ],
      enableCellTextSelection: true,
      alwaysShowHorizontalScroll: true,
      alwaysShowVerticalScroll: true,
      getRowStyle,
    };
  }

  constructor() {
    this.gridOptions = OrdersGridComponent.defaultOptions();
  }



  ngOnInit(): void {
    this.customStyle.width = this.w + 'px';

    this.intId = setInterval(() => {
      this.updateGridWidth();
    }, 1000);

    this.inputFC.valueChanges.pipe(debounceTime(250)).subscribe((value: any) => {
      this.filterChange.emit(value);
    });
  }

  ngOnDestroy(): void {
    this.intId && clearInterval(this.intId);
    this.wId && clearInterval(this.wId);
  }

  setRowData(rowData: any[]) {
    //MyLog.log('Grid:rows:', rowData);
    this.rowData = rowData;
    this.updateColumnSizes();
  }

  updateColumnSizes() {
    const g = this._grid?.api?.columnApi;

    if (g && !g.destroyCalled) {
      /*
      if(this.autofit) {
        MyLog.log('DO AUTOFIT');
        g.sizeColumnsToFit();
      } else {
      }
      */
      g.autoSizeColumns();
    }
  }
}
